/**
 * Returns true when the event target is an element that accepts text input
 * (input, textarea, or contentEditable). Useful for guarding keyboard
 * shortcuts so they don't fire while the user is typing.
 */
export function isEditableElement(target: EventTarget | null): boolean {
    return (
        target instanceof HTMLInputElement ||
        target instanceof HTMLTextAreaElement ||
        (target instanceof HTMLElement && target.isContentEditable)
    );
}
